var map = {
	"./bio-based-waste-stream-biocomposite/block-2.png": [
		9293,
		9293
	],
	"./bio-based-waste-stream-biocomposite/block-3.png": [
		9348,
		9348
	],
	"./bio-based-waste-stream-biocomposite/block-4.png": [
		4651,
		4651
	],
	"./bio-based-waste-stream-biocomposite/block-5.png": [
		6786,
		6786
	],
	"./bio-based-waste-stream-biocomposite/block-6.png": [
		7497,
		7497
	],
	"./bio-based-waste-stream-biocomposite/block-7.png": [
		2672,
		2672
	],
	"./bio-based-waste-stream-biocomposite/block-8.png": [
		6903,
		6903
	],
	"./bio-based-waste-stream-biocomposite/block-large.png": [
		6466,
		6466
	],
	"./bio-based-waste-stream-biocomposite/block.png": [
		2648,
		2648
	],
	"./biochar-based-bioplastic/block-2.png": [
		4324,
		4324
	],
	"./biochar-based-bioplastic/block-3.png": [
		8221,
		8221
	],
	"./biochar-based-bioplastic/block-large.png": [
		607,
		607
	],
	"./biochar-based-bioplastic/block.png": [
		3549,
		3549
	],
	"./biodegradable-and-bio-based-materials/block-2.png": [
		6072,
		6072
	],
	"./biodegradable-and-bio-based-materials/block-3.png": [
		4465,
		4465
	],
	"./biodegradable-and-bio-based-materials/block-large.png": [
		6155,
		6155
	],
	"./biodegradable-and-bio-based-materials/block.png": [
		313,
		313
	],
	"./biodegradable-biopolymer/block-2.png": [
		5483,
		5483
	],
	"./biodegradable-biopolymer/block-3.png": [
		4978,
		4978
	],
	"./biodegradable-biopolymer/block-large.png": [
		3100,
		3100
	],
	"./biodegradable-biopolymer/block.png": [
		2834,
		2834
	],
	"./cellulose-acoustic-panel/block-2.png": [
		7800,
		7800
	],
	"./cellulose-acoustic-panel/block-3.png": [
		7745,
		7745
	],
	"./cellulose-acoustic-panel/block-large.png": [
		171,
		171
	],
	"./cellulose-acoustic-panel/block.png": [
		9593,
		9593
	],
	"./compostable-foam/block-2.png": [
		6858,
		6858
	],
	"./compostable-foam/block-3.png": [
		4435,
		4435
	],
	"./compostable-foam/block-large.png": [
		9329,
		9329
	],
	"./compostable-foam/block.png": [
		5527,
		5527
	],
	"./cork-based-material/block-2.png": [
		3320,
		3320
	],
	"./cork-based-material/block-3.png": [
		4449,
		4449
	],
	"./cork-based-material/block-4.png": [
		6734,
		6734
	],
	"./cork-based-material/block-5.png": [
		2311,
		2311
	],
	"./cork-based-material/block-6.png": [
		4204,
		4204
	],
	"./cork-based-material/block-large.png": [
		4984,
		2603
	],
	"./cork-based-material/block.png": [
		6633,
		6633
	],
	"./fish-scale-board/block-2.png": [
		6283,
		6283
	],
	"./fish-scale-board/block-3.png": [
		1458,
		1458
	],
	"./fish-scale-board/block-4.png": [
		6317,
		6317
	],
	"./fish-scale-board/block-large.png": [
		1372,
		1372
	],
	"./fish-scale-board/block.png": [
		322,
		322
	],
	"./kraft-lignin/block-2.png": [
		8887,
		8887
	],
	"./kraft-lignin/block-large.png": [
		2704,
		2704
	],
	"./kraft-lignin/block.png": [
		22,
		22
	],
	"./lignin-nanoparticles/block-2.png": [
		9900,
		9900
	],
	"./lignin-nanoparticles/block-large.png": [
		8004,
		8004
	],
	"./lignin-nanoparticles/block.png": [
		5797,
		5797
	],
	"./microalgae-derived-zero-carbon-bio-cement/block-2.png": [
		3702,
		3702
	],
	"./microalgae-derived-zero-carbon-bio-cement/block-3.png": [
		2719,
		2719
	],
	"./microalgae-derived-zero-carbon-bio-cement/block-large.png": [
		8405,
		8405
	],
	"./microalgae-derived-zero-carbon-bio-cement/block.png": [
		1707,
		1707
	],
	"./mycelium-based-acoustic-panels/block-2.png": [
		5500,
		5500
	],
	"./mycelium-based-acoustic-panels/block-3.png": [
		7125,
		7125
	],
	"./mycelium-based-acoustic-panels/block-4.png": [
		5066,
		5066
	],
	"./mycelium-based-acoustic-panels/block-5.png": [
		4899,
		4899
	],
	"./mycelium-based-acoustic-panels/block-6.png": [
		2920,
		2920
	],
	"./mycelium-based-acoustic-panels/block-7.png": [
		4961,
		4961
	],
	"./mycelium-based-acoustic-panels/block-large.png": [
		9543,
		9543
	],
	"./mycelium-based-acoustic-panels/block.png": [
		821,
		821
	],
	"./mycelium-based-building-material/block-2.png": [
		173,
		173
	],
	"./mycelium-based-building-material/block-3.png": [
		6276,
		6276
	],
	"./mycelium-based-building-material/block-large.png": [
		1234,
		1234
	],
	"./mycelium-based-building-material/block.png": [
		7032,
		7032
	],
	"./osl/block-2.png": [
		4455,
		4455
	],
	"./osl/block-large.png": [
		496,
		496
	],
	"./osl/block.png": [
		5910,
		5910
	],
	"./placeholder.png": [
		2253,
		2253
	],
	"./plastic-free-leather/block-2.png": [
		8604,
		8604
	],
	"./plastic-free-leather/block-3.png": [
		4053,
		4053
	],
	"./plastic-free-leather/block-4.png": [
		7546,
		7546
	],
	"./plastic-free-leather/block-5.png": [
		1152,
		8771
	],
	"./plastic-free-leather/block-6.png": [
		3496,
		3496
	],
	"./plastic-free-leather/block-large.png": [
		7543,
		7543
	],
	"./plastic-free-leather/block.png": [
		8021,
		8021
	],
	"./polycrystalline-silicon/block-2.png": [
		76,
		7695
	],
	"./polycrystalline-silicon/block-3.png": [
		1366,
		1366
	],
	"./polycrystalline-silicon/block-large.png": [
		6280,
		6280
	],
	"./polycrystalline-silicon/block.png": [
		2846,
		2846
	],
	"./recycled-paper-boards/block-2.png": [
		1799,
		1799
	],
	"./recycled-paper-boards/block-3.png": [
		9310,
		9310
	],
	"./recycled-paper-boards/block-large.png": [
		2464,
		2464
	],
	"./recycled-paper-boards/block.png": [
		1990,
		1990
	],
	"./recycled-paper-composite/block-2.png": [
		1457,
		1457
	],
	"./recycled-paper-composite/block-3.png": [
		3592,
		3592
	],
	"./recycled-paper-composite/block-large.png": [
		1374,
		1374
	],
	"./recycled-paper-composite/block.png": [
		8471,
		852
	],
	"./recycled-paper-panel/block-2.png": [
		7786,
		7786
	],
	"./recycled-paper-panel/block-3.png": [
		5363,
		5363
	],
	"./recycled-paper-panel/block-large.png": [
		9185,
		9185
	],
	"./recycled-paper-panel/block.png": [
		119,
		119
	],
	"./seaweed-paper/block-2.png": [
		6350,
		6350
	],
	"./seaweed-paper/block-3.png": [
		4663,
		4663
	],
	"./seaweed-paper/block-4.png": [
		9496,
		9496
	],
	"./seaweed-paper/block-large.png": [
		9597,
		9597
	],
	"./seaweed-paper/block.png": [
		7043,
		7043
	],
	"./sodium-lignosulfonate/block-2.png": [
		395,
		395
	],
	"./sodium-lignosulfonate/block-large.png": [
		9708,
		9708
	],
	"./sodium-lignosulfonate/block.png": [
		8594,
		8594
	],
	"./starch-based-composite/block-2.png": [
		3674,
		3674
	],
	"./starch-based-composite/block-3.png": [
		9235,
		9235
	],
	"./starch-based-composite/block-4.png": [
		1836,
		1836
	],
	"./starch-based-composite/block-large.png": [
		9537,
		9537
	],
	"./starch-based-composite/block.png": [
		5623,
		5623
	],
	"./waste-leaf-paper/block-2.png": [
		3249,
		3249
	],
	"./waste-leaf-paper/block-large.png": [
		9774,
		9774
	],
	"./waste-leaf-paper/block.png": [
		8708,
		8708
	],
	"./water-resistant-lignin-coating/block-2.png": [
		8872,
		8872
	],
	"./water-resistant-lignin-coating/block-3.png": [
		7137,
		7137
	],
	"./water-resistant-lignin-coating/block-4.png": [
		1022,
		1022
	],
	"./water-resistant-lignin-coating/block-large.png": [
		7099,
		7099
	],
	"./water-resistant-lignin-coating/block.png": [
		1401,
		1401
	],
	"./wood-based-plastic-alternative/block-2.png": [
		2611,
		2611
	],
	"./wood-based-plastic-alternative/block-large.png": [
		7604,
		7604
	],
	"./wood-based-plastic-alternative/block.png": [
		154,
		154
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7119;
module.exports = webpackAsyncContext;